module.exports = __webpack_public_path__ + "static/GetStarted-3-2c875d3c3e10643e91b95dbb5f4badcc.jpg";